import React from 'react'
import PropTypes from 'prop-types'
import {
  constants,
  CheckboxField,
  EnhancedDropdown,
  withApplicationContext,
} from '@adc/ui-adc'
import { track } from '@adc/analytics'
import classnames from 'classnames/bind'
import { NEARBY_SEARCH_RADIUS_OPTIONS } from '../../constants/filters'
import { checkIsNearbySearch } from '../../util/nearbyCheckbox'
import { getDefaultNearbyRadius } from '../../util/seekConversion'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const { ColorNames } = constants

const NearbyCheckbox = ({
  filters,
  assets,
  elmId,
  updateFiltersAction,
  applicationContext,
}) => {
  const toggleNearbySearch = isNearbySearch => {
    const useNearbySearch = isNearbySearch ? 'y' : 'n'
    updateFiltersAction({ useNearbySearch })
  }

  const setNearbySearchRadius = value => {
    track('search-area-filter', { filterValue: String(value) })
    updateFiltersAction({ nearbySearchRadius: value })
  }

  const onChange = (_, { checked }) => {
    track('search-area-filter', {
      filterValue: checked ? filters.nearbySearchRadius || '50' : 'Exact',
    })
    toggleNearbySearch(checked)
  }

  const { fetchProgress } = assets
  const { useNearbySearch, nearbySearchRadius, globalSearch } = filters
  const isNearbySearch = useNearbySearch === 'y'
  const isGlobalSearch = globalSearch === 'y'
  const showNearbyCheckbox =
    checkIsNearbySearch(filters.city, filters.zip, filters.county) &&
    !isGlobalSearch
  const nearbySearchValue =
    nearbySearchRadius ||
    getDefaultNearbyRadius(applicationContext.featureFlags)

  return (
    <div className={cx('checkbox')}>
      {showNearbyCheckbox && (
        <>
          <CheckboxField
            checkboxLabel='Within:'
            checked={isNearbySearch}
            disabled={fetchProgress.loading}
            elmId={`${elmId}_nearby_search`}
            hideLabel
            onChange={onChange}
            style={{ color: ColorNames.Black }}
          />

          <EnhancedDropdown
            className={cx('nearby-dropdown')}
            elmId={`${elmId}_nearby_search_radius`}
            disabled={!isNearbySearch}
            inline
            variant='enhanced'
            direction='right'
            options={NEARBY_SEARCH_RADIUS_OPTIONS}
            selectedValue={nearbySearchValue}
            onSelect={setNearbySearchRadius}
            text={
              NEARBY_SEARCH_RADIUS_OPTIONS.find(
                o => String(o.value) === String(nearbySearchValue)
              )?.text || `${nearbySearchValue} Miles`
            }
          />
        </>
      )}
    </div>
  )
}

NearbyCheckbox.propTypes = {
  filters: PropTypes.object.isRequired,
  assets: PropTypes.object.isRequired,
  elmId: PropTypes.string.isRequired,
  updateFiltersAction: PropTypes.func.isRequired,
  applicationContext: PropTypes.object.isRequired,
}

export default withApplicationContext(NearbyCheckbox)
